import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/* ==============================================
ヘッダーの部分
============================================== */
export function servicesFunc() {
  let servicesTop = $("#servicesTop").length;

  if (servicesTop) {
    // subNavHeightFunc();

    subNavAccordionFuc();

    subNavScrollFunc();

    // function subNavHeightFunc() {
    //   let subNavHeight = $(".subNav");
    //   let headerHeight = $("#header").outerHeight();
    //   subNavHeight.css("top", `${headerHeight}px`);

    //   let setTimer = false;
    //   $(window).on("resize", function () {
    //     if (setTimer !== false) {
    //       clearTimeout(setTimer);
    //     }
    //     setTimer = setTimeout(() => {
    //       subNavHeightFunc();
    //     }, 200);
    //   });
    // }

    function subNavAccordionFuc() {
      const servicesSubNavAccordionBtn = $("#servicesSubNav .accordionBtn");
      const servicesSubNav = $("#servicesSubNavList a");
      let resizecheck = $("#responsibleCheck").width();
      let resizecheck2 = 0;

      $(window).on("load resize", function () {
        resizecheck = $("#responsibleCheck").width();
        subNavAccordionMenuStart();
        subNavCloseFunc();
      });

      //スマホのみサブナビをクリックでクローズさせる
      function subNavCloseFunc() {
        if (resizecheck == "2") {
          servicesSubNav.on("click", subNavClickHandler);
        } else if (resizecheck == "1") {
          servicesSubNav.off("click", subNavClickHandler);
        }
      }
      function subNavClickHandler() {
        servicesSubNavAccordionBtn.next("dd").slideUp(500);
        $("#servicesSubNav").removeClass("isNavOpen");
        servicesSubNavAccordionBtn.removeClass("isOpen");
      }
      subNavCloseFunc();

      servicesSubNavAccordionBtn.on("click", function () {
        const subNav = $("#servicesSubNav");

        if (resizecheck == "2") {
          if ($(this).hasClass("isOpen")) {
            $(this)
              .next("dd")
              .slideUp(500, function () {
                subNav.removeClass("isNavOpen");
              });
            $(this).removeClass("isOpen");
          } else {
            servicesSubNavAccordionBtn.next("dd").slideUp(500);
            servicesSubNavAccordionBtn.removeClass("isOpen");
            $(this).next("dd").slideDown(500);
            $(this).addClass("isOpen");

            subNav.addClass("isNavOpen");
          }
        }
      });

      var subNavAccordionMenuStart = function () {
        let resizecheck = $("#responsibleCheck").width();
        if (resizecheck == "2" && resizecheck != resizecheck2) {
          servicesSubNavAccordionBtn.next("dd").css("display", "none");
          resizecheck2 = 2;
        } else if (resizecheck == "1" && resizecheck != resizecheck2) {
          servicesSubNavAccordionBtn.removeClass("isOpen");
          servicesSubNavAccordionBtn.next("dd").css("display", "block");
          resizecheck2 = 1;
        }
      };
      subNavAccordionMenuStart();
    }

    function subNavScrollFunc() {
      // 今回の交差を監視する要素
      const boxes = document.querySelectorAll(".servicesList .list");

      const options = {
        root: null,
        rootMargin: "0% 0px -87%",
        threshold: 0,
      };
      const observer = new IntersectionObserver(doWhenIntersect, options);
      boxes.forEach((box) => {
        observer.observe(box);
      });

      /**
       * 交差したときに呼び出す関数
       * @param entries
       */
      function doWhenIntersect(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activateIndex(entry.target);
          }
        });
      }
      /**
       * 目次を変える関数
       * @param element
       */
      function activateIndex(element) {
        const currentActiveIndex = document.querySelector("#servicesSubNavList .active");
        if (currentActiveIndex !== null) {
          currentActiveIndex.classList.remove("active");
        }
        const newActiveIndex = document.querySelector(`a[href='#${element.id}']`).parentElement;
        newActiveIndex.classList.add("active");

        const currentTxt = document.querySelector(`a[href='#${element.id}']`).textContent;
        $("#navCurrent").text(currentTxt).css({ color: "#fff" });
      }
    }

    $(window).on("load scroll", function () {
      var subNavCurrent = $("#servicesSubNavList .pageLinkList");
      var scroll = $(window).scrollTop();
      if (scroll == 0) {
        $("#navCurrent").text("TENGA 20th Anniversary").css({ color: "#fff" });
        if (subNavCurrent.hasClass("active")) {
          subNavCurrent.removeClass("active");
        }
      }
    });
  }
}

export function animation() {
  // 商品ホバー時（PC）
  $(function () {
    $(".productItemOther").each(function (index) {
      $(this).on("mouseenter", function () {
        // 全キャラを一旦リセット
        $(".productCharaItem").css("opacity", "1");

        // キャラ 0.7
        $(".productCharaItem").eq(index).css("opacity", ".7");

        // 商品 0.7
        $(this).find(".product__swiper-slide-img, .product__swiper-slide-txt-wrap").css("opacity", ".7");
      });

      $(this).on("mouseleave", function () {
        // 全てを元に戻す
        $(".productCharaItem").css("opacity", "1");
        $(this).find(".product__swiper-slide-img, .product__swiper-slide-txt-wrap").css("opacity", "1");
      });
    });
  });
  // 商品ホバー時（SP）

  /* =============================================
gsap
============================================= */
  // FV
  window.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  let tl = gsap.timeline();

  // 1人目
  tl.fromTo(".fvItemBg.first", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });
  tl.to(".fvItem.first", { "--before-opacity": 1, duration: 0.3 }, ">");
  tl.fromTo(".fvItemProduct.first", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 }, ">");

  // 2人目
  tl.fromTo(".fvItemBg.second", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 }, ">");
  tl.to(".fvItem.second", { "--before-opacity": 1, duration: 0.3 }, ">");
  tl.fromTo(".fvItemProduct.second", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 }, ">");

  // 3人目
  tl.fromTo(".fvItemBg.third", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 }, ">");
  tl.to(".fvItem.third", { "--before-opacity": 1, duration: 0.3 }, ">");
  tl.fromTo(".fvItemProduct.third", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 }, ">");

  // 4人目
  tl.fromTo(".fvItemBg.four", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 }, ">");
  tl.to(".fvItem.four", { "--before-opacity": 1, duration: 0.3 }, ">");
  tl.fromTo(".fvItemProduct.four", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 }, ">");

  // ==== fvTxt2 出し分け ====
  const isSP = window.matchMedia("(max-width: 768px)").matches;
  const txtClass = isSP ? ".fvTxt2SP" : ".fvTxt2";

  tl.fromTo(
    `.fvLogo, .fvLogo2, ${txtClass}`,
    { autoAlpha: 0 },
    { autoAlpha: 1, ease: "power1.inOut" },
    "<1"
  );
});


  //各セクションごとのフェードイン
  gsap.utils.toArray(".fadeIn").forEach((target) => {
    gsap.fromTo(
      target,
      { autoAlpha: 0 },
      {
        autoAlpha: 1,
        scrollTrigger: {
          trigger: target,
          start: "top 70%",
          // markers:true,
        },
      }
    );
  });

  //血飛沫（単体）
  gsap.utils.toArray(".DecoFadeIn").forEach((target) => {
    gsap.fromTo(
      target,
      { display: "none" },
      {
        display: "block",
        scrollTrigger: {
          trigger: target,
          start: "top 70%",
          // markers: true,
        },
      }
    );
  });
  // 血飛沫
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const decoTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: ".introVideo",
        start: "top 70%",
      },
    });

    decoTimeline.fromTo(".introVideoDeco1", { display: "none" }, { display: "block" });

    decoTimeline.fromTo(".introVideoDeco2", { display: "none" }, { display: "block" },">-.3");
  });

  // 血飛沫（製品情報）
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const classesPC = ["second", "first", "four", "five", "five"];
    const classesSP = ["detailItemDecoSP first", "second", "four", "five"];
    gsap.utils.toArray(".detailItem").forEach((item) => {
      classesPC.forEach((cls, index) => {
        const deco = item.querySelector(`.detailItemDeco.${cls} .pcOnly`);
        if (deco) {
          // indexに応じてstart位置をずらす
          const startOffset = 50 + index * 2; // first=50%, second=60%, third=70%...

          gsap.fromTo(
            deco,
            { display: "none" },
            {
              display: "block",
              scrollTrigger: {
                trigger: deco,
                start: `top ${startOffset}%`,
              },
            }
          );
        }
      });
    });

    // SP用（768px以下）
  gsap.matchMedia().add("(max-width: 768px)", () => {
    gsap.utils.toArray(".detailItem").forEach((item) => {
      classesSP.forEach((cls) => {
        const deco = item.querySelector(`.${cls.replace(" ", ".")}`);
        if (deco) {
          gsap.fromTo(
            deco,
            { display: "none" },
            {
              display: "block",
              scrollTrigger: {
                trigger: deco,
                start: "top 60%",
                // markers: true,
              },
            }
          );
        }
        });
      });
    });
  });

  // 血飛沫(スペシャルボックス)
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const decoTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: ".specialBottomBox",
        start: "top 80%",
      },
    });

    decoTimeline.fromTo(".specialBottomBoxDeco2", { display: "none" }, { display: "block" });
    decoTimeline.fromTo(".specialBottomBoxDeco1", { display: "none" }, { display: "block" },">-.3");
  });

  // 血飛沫(スペック)
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const decoTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: ".specList",
        start: "top 80%",
      },
    });

    decoTimeline.fromTo(".specDeco1", { display: "none" }, { display: "block" });
    decoTimeline.fromTo(".specDeco2", { display: "none" }, { display: "block" });
  });

  // 血飛沫(取扱店舗)
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  gsap.to(".shopListDeco", {
    "--before-display": "block",
    scrollTrigger: {
      trigger: ".shopList",
      start: "7% 80%",
    },
  });
});
  // 追従ボタン
  window.addEventListener("scroll", function () {
    const trigger = document.getElementById("js-floating-start");
    const triggerEnd = document.getElementById("js-floating-end");
    const fixContent = document.getElementById("fixedBtnWrap");
    const scrollValue = window.scrollY;
    const clientRect = trigger.getBoundingClientRect();
    const clientRectEnd = triggerEnd.getBoundingClientRect();
    const py = window.pageYOffset + clientRect.top - window.innerHeight;
    const ey = window.pageYOffset + clientRectEnd.top;
    if (py < scrollValue && ey > scrollValue + window.innerHeight) {
      fixContent.classList.add("is-show");
    } else {
      fixContent.classList.remove("is-show");
    }
  });
}

/* =============================================
商品のスライダー
============================================= */
// // 初期化・破壊を切り替える関数
// let swiperInstance = null;

// function toggleSwiper1() {
//   const isSP1 = window.matchMedia("(max-width: 767px)").matches;
//   const swiperEl1 = document.querySelector(".product__swiper");

//   if (isSP1) {
//     // SPサイズならSwiperを初期化
//     if (!swiperInstance) {
//       swiperInstance = new Swiper(swiperEl1, {
//         speed: 1000,
//         effect: "slide",
//         allowTouchMove: true,
//         loop: true,
//         autoplay: {
//           delay: 3000,
//           disableOnInteraction: false,
//         },

//         centeredSlides: true,
//         slidesPerView: 1,
//         spaceBetween: 0,
//         // spaceBetween: window.innerWidth * 0.094,

//         pagination: {
//           el: ".swiper-pagination",
//           clickable: true,
//           type: "bullets",
//         },
//         navigation: {
//           prevEl: ".swiper-button-prev",
//           nextEl: ".swiper-button-next",
//         },
//       });
//     }
//   } else {
//     // PCサイズならSwiperを破棄
//     if (swiperInstance) {
//       swiperInstance.destroy(true, true);
//       swiperInstance = null;

//       // SP用に付与されたクラスやスタイルを完全リセット
//       swiperEl1.classList.remove("swiper-initialized", "swiper-horizontal", "swiper-backface-hidden", "swiper-free-mode", "swiper-wp8-horizontal");
//       swiperEl1.querySelectorAll(".swiper-slide").forEach((slide) => {
//         slide.style.width = "";
//         slide.style.marginRight = "";
//       });

//       // 必要ならpaginationやnavigationもリセット
//       const pag = swiperEl1.querySelector(".swiper-pagination");
//       if (pag) pag.innerHTML = "";
//     }
//   }
//   const productSwiper = new Swiper(".productWrap", {
//     // ここは既存の設定に合わせて OK
//     on: {
//       slideChange: function () {
//         // 一旦全部非表示
//         const charas = document.querySelectorAll(".product__swiper-slide-chara");
//         charas.forEach((c) => (c.style.opacity = 0));

//         // active index に対応するキャラだけ表示
//         const activeIndex = this.activeIndex;
//         const activeChara = document.querySelector(`.product__swiper-slide-chara:nth-of-type(${activeIndex + 1})`);
//         if (activeChara) activeChara.style.opacity = 1;
//       },
//     },
//   });
// }

// // 初回実行
// toggleSwiper1();
// // リサイズ時も切り替え
// window.addEventListener("resize", toggleSwiper1);
